import { render, staticRenderFns } from "./SmsModal.vue?vue&type=template&id=55a066aa&scoped=true"
import script from "./SmsModal.vue?vue&type=script&lang=js"
export * from "./SmsModal.vue?vue&type=script&lang=js"
import style0 from "./SmsModal.vue?vue&type=style&index=0&id=55a066aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a066aa",
  null
  
)

export default component.exports